import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class VehicleGroupStore {
  vehicleGroupVehicles = [];
  loading = false;
  assetList = [];
  vehicleArray = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      vehicleGroupVehicles: observable,
      loading: observable,
      vehicleArray: observable,
      loadData: action,
      addData: action,
      getVehicleGroupData: action,
      getAssetData: action,
      deleteRecord: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId }) {
    this.loading = true;

    var postData = { companyId: companyId, userId: null };

    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("deviceGroup/getDeviceGroup", {
        params: postData,
      });

    this.vehicleGroupVehicles =
      response?.data?.DeviceGroupData[0]?.devicegroups;
    this.loading = false;
  }

  async addData(postData) {
    var vehicleGroupData = { postData };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("deviceGroup/updateDeviceGroups", vehicleGroupData);

    return response;
  }

  async getVehicleGroupData(deviceGroupId, companyId) {
    var postData = {
      deviceGroupId: deviceGroupId,
      limit: 1,
      offset: 0,
      companyId: companyId,
    };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("deviceGroup/getDeviceGroup", {
        params: postData,
      });
    this.vehicleArray =
      response.data.DeviceGroupData[0].devicegroups[0].vehicles;
    return response.data.DeviceGroupData[0].devicegroups[0];
  }

  // To get asset list
  async getAssetData(companyId) {
    var postData = { companyId: companyId };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("/vehicle/getVehicles", {
        params: postData,
      });

    this.assetList = response?.data?.vehicleData;
    return response?.data?.vehicleData;
  }

  async deleteRecord({ deviceGroupId }) {
    var response = await postApi
      .getClient("NodeCoreUrl")
      .delete("deviceGroup/deleteDeviceGroup", {
        params: {
          deviceGroupId: deviceGroupId,
        },
      });
    return response;
  }
}

export default VehicleGroupStore;
